import { ListItem } from '@components/ListItem';
import { twJoin, twMerge } from '@beerntea/pitcher-ui';
import type { UsatourDate } from '@pages/Usa/UsaPage.tsx';
import { ArrowUpRightIcon } from 'lucide-react';

interface Props {
  tourDate: UsatourDate;
  passRef: (el: HTMLAnchorElement | null) => void;
  onClick?: () => void;
}

export function TourDatesListItem({ tourDate, passRef, onClick }: Props) {
  return (
    <a
      href={tourDate.url}
      ref={(el) => passRef(el)}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick();
        }
      }}
      className="tw-block"
    >
      <ListItem
        label={
          <div
            className={twJoin(
              'tw-flex tw-font-display tw-flex-wrap tw-gap-x-2 tw-items-center',
              'md:tw-text-2xl md:tw-gap-x-4',
              'lg:tw-text-3xl',
            )}
          >
            <span className="">{tourDate.date}</span>
            <span className="tw-font-display tw-font-bold">{tourDate.venue}</span>
            <span className="tw-font-sans tw-text-xs ">{tourDate.location}</span>
          </div>
        }
        subText={
          <div className={twMerge('tw-inline-flex tw-gap-2 tw-items-center tw-whitespace-nowrap')}>
            <span className="tw-font-display max-sm:tw-text-[12px] tw-text-sm tw-font-light">{tourDate.status}</span>
            <span className="tw-inline-grid tw-size-4 tw-place-content-center">
              {['TBA', 'SOLD OUT'].indexOf(tourDate.status) > 0 ? '' : <ArrowUpRightIcon size={16} />}
            </span>
          </div>
        }
        className=""
      />
    </a>
  );
}
